<template>
  <el-dialog
    title="风险设备详情"
    :close-on-click-modal="false"
    top="80px"
    append-to-body
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-form label-width="120px"
    >
      <el-form-item label="渠道+UID" prop="level">
        <div class="info"> 渠道：{{riskDevice.appid}}</div>
        <div class="info">UID：{{riskDevice.uid}}</div>
      </el-form-item>
      <el-form-item label="Mac 地址" prop="mac">
        <div class="info">{{riskDevice.mac}}</div>
      </el-form-item>
      <el-form-item label="AndroidID" prop="androidID">
        <div class="info">{{riskDevice.androidId}}</div>
      </el-form-item>
      <el-form-item label="IDFA" prop="idfa">
        <div class="info">{{riskDevice.idfa}}</div>
      </el-form-item>
      <el-form-item label="风险等级" prop="level">
        <div class="level-wrapper">
          <div class="level">{{risks.level}}</div>
          <div class="desc">{{risks.desc}}</div>
        </div>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <div class="info">{{ riskDevice.remark }}</div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  props: {
    riskLevel: Object,
    riskDevice: Object
  },
  data() {
    return {
      riskForm: {
        riskLevel: 2
      },
      riskLevels: {
        3: {
          level: "高风险",
          desc: "高风险设备，会执行封禁，封禁后，应用侧无法使用相关功能"
        },
        2: {
          level: "中风险",
          desc: "中风险设备，登录需要进行人脸认证登录、发端连接及投屏时触发防诈提示"
        },
        1: {
          level: "低风险",
          desc: "低风险设备，发端连接及投屏时触发防诈提示"
        },
        0: {
          level: "无风险",
          desc: "无风险设备，不执行相关防诈提示"
        }
      },
      risks: {
        level: '',
        desc: ''
      }
    }
  },
  watch: {
    "$attrs.visible"(nVal) {
      console.log('===', nVal)
      this.risks = this.riskLevels[this.riskDevice.level] || {
        level: '',
        desc: ''
      }
      if(!nVal) {
        console.log('重置')
      } else {
        console.log('查看的风险等级')
        console.log(this.riskLevel)
        console.log(this.riskDevice)
      }
    }
  },
  mounted() {
    console.log('查看的风险等级')
    console.log(this.riskDevice)
  },
  methods: {
    onSave() {
      console.log('确定')
      this.$emit("update:visible", false)
    },
    cancel() {
      console.log('取消')
      this.$emit("update:visible", false)
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-card__header {
  background: #f5f7fa;
}
.info {
  color: #333;
}
</style>
